import { useButtonBack, useButtonNext } from '../../_methods'
import RoundedButton from 'components/Common/MasterComponents/Buttons/RoundedButton'
import ChevronLeft from 'components/Common/Icons/ChevronLeft'
import styled from 'styled-components'
import { useCarousel } from '../..'

const LeftWrapper = styled.div`
  position: absolute;
  transform: translateX(8px) translateY(16px);
  left: 0;
  z-index: 1;
`
const RightWrapper = styled.div`
  position: absolute;
  transform: rotate(180deg) translateX(8px) translateY(-16px);
  right: 0;
  z-index: 1;
`

const ButtonBack = () => {
  const { currentImage } = useCarousel()
  const { onClick, disabled } = useButtonBack()

  if (disabled || currentImage === 0) return null

  return (
    <LeftWrapper>
      <RoundedButton type='secondary' size='M' onClick={onClick}>
        <ChevronLeft />
      </RoundedButton>
    </LeftWrapper>
  )
}

const ButtonNext = () => {
  const { onClick, disabled } = useButtonNext()
  const { currentImage, totalImages } = useCarousel()

  if (disabled || currentImage === totalImages - 1) return null

  return (
    <RightWrapper>
      <RoundedButton type='secondary' size='M' onClick={onClick}>
        <ChevronLeft />
      </RoundedButton>
    </RightWrapper>
  )
}

export { ButtonBack, ButtonNext }
